import React, { useState, useEffect } from 'react';
import api, { STORAGE_URL } from '../services/api';

export default function VideoGallery() {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchVideos = async () => {
            try {
                const response = await api.get('/videos?frontend=true');
                setVideos(response.data.data || []);
            } catch (error) {
                console.error("Error fetching videos:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchVideos();
    }, []);

    if (loading || videos.length === 0) {
        return null;
    }

    const getEmbedUrl = (url) => {
        if (!url) return null;
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[2].length === 11) ? `https://www.youtube.com/embed/${match[2]}` : url;
    };

    return (
        <section className="pt-6 pb-16 bg-transparent dark:bg-transparent transition-colors duration-300 relative">
            
            {/* 🌟 Background Soft Glow Effect (Optional lekin acha lagta hai) */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-32 bg-yellow-400/10 blur-[100px] -z-10 rounded-full pointer-events-none"></div>

            {/* Container ko thoda aur wide kiya hai taaki 4 videos theek se fit hon */}
            <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:px-8">
                
                {/* 🌟 Heading UI Improved */}
                <div className="text-center mb-10">
                    <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 dark:text-white tracking-tight">
                        Job Details <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">Videos</span>
                    </h2>
                    <p className="mt-4 text-sm md:text-base text-gray-600 dark:text-gray-400 max-w-2xl mx-auto font-medium">
                        Explore our latest job-related videos, tutorials, and insights to help you navigate your career journey.
                    </p>
                </div>

                {/* 🌟 FLEX CONTAINER FOR HORIZONTAL SCROLL */}
                <div className="flex overflow-x-auto gap-6 pb-8 snap-x snap-mandatory scroll-smooth [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
                    
                    {videos.map((video) => (
                        <div 
                            key={video.id} 
                            // 🌟 1 Line mein 4 Videos ka Calculation (Desktop pe 4, Tablet pe 2, Mobile pe 1)
                            className="flex-none snap-start w-[85vw] sm:w-[calc(50%-0.75rem)] lg:w-[calc(25%-1.125rem)] bg-white dark:bg-gray-800/80 backdrop-blur-xl rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(0,0,0,0.1)] border border-gray-100 dark:border-gray-700/50 flex flex-col transition-all duration-300 hover:-translate-y-2 group overflow-hidden"
                        >
                            
                            <div className="aspect-video w-full bg-gray-100 dark:bg-gray-900 relative overflow-hidden">
                                {/* Subtle dark overlay jo hover karne par hat jayega */}
                                <div className="absolute inset-0 bg-black/10 group-hover:bg-transparent transition-colors duration-300 z-10 pointer-events-none"></div>
                                
                                {video.video_url ? (
                                    <iframe 
                                        src={getEmbedUrl(video.video_url)} 
                                        title={video.title}
                                        className="w-full h-full absolute top-0 left-0 z-0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                ) : (
                                    <video 
                                        controls 
                                        poster={video.thumbnail ? STORAGE_URL(video.thumbnail) : ''}
                                        className="w-full h-full absolute top-0 left-0 object-cover z-0"
                                    >
                                        <source src={STORAGE_URL(video.video_file)} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                )}
                            </div>
                            
                            <div className="p-5 flex-1 flex flex-col justify-center bg-gradient-to-b from-transparent to-gray-50/50 dark:to-gray-800/50">
                                <h3 className="font-bold text-gray-800 dark:text-gray-100 text-base md:text-lg line-clamp-2 group-hover:text-yellow-600 dark:group-hover:text-yellow-400 transition-colors">
                                    {video.title}
                                </h3>
                                {/* 🌟 Hover par extend hone wali aesthetic yellow line */}
                                <div className="h-1 w-12 bg-yellow-500 rounded-full mt-4 transform origin-left transition-all duration-300 group-hover:w-full opacity-50 group-hover:opacity-100"></div>
                            </div>
                            
                        </div>
                    ))}
                    
                </div>
            </div>
        </section>
    );
}